import SectionTitle from "@/components/SectionTitle/SectionTitle.vue";
import { mapGetters } from "vuex";
import agencyService from "@/services/agency";
import { WEEK_DAYS } from "@/constants/variables";
import Utils from "@/mixins/Utils";

export default {
  components: {
    SectionTitle,
  },
  data() {
    return {
      agency: {},
      center: {},
      weekdays: Object.values(WEEK_DAYS),
      showGoogleMap: true,
      googleApiKey:  window.configs && window.configs.VUE_APP_GOOGLE_API_KEY !== "" 
      ? window.configs.VUE_APP_GOOGLE_API_KEY: process.env.VUE_APP_GOOGLE_API_KEY
    };
  },
  mixins: [Utils],
  computed: {
    ...mapGetters({
      loading: "isLoading",
      errorMessage: "errorMessage",
    }),

    staticMapLinkURL() {
      if (this.agency.lat && this.agency.lng)
        return `http://maps.google.com/maps?q=${this.agency.lat},${this.agency.lng}`;
    },

    staticMapURL() {
      if (this.agency.lat && this.agency.lng)
        return `https://maps.google.com/maps/api/staticmap?
          center=${this.agency.lat},${this.agency.lng}
          &size=365x256&scale=1&sensor=false&zoom=16
          &markers=${this.agency.lat}%2C${this.agency.lng}
          &key=${this.googleApiKey}`;
    },

    agencyMarkers() {
      return [{
        lat: this.agency.lat || 0,
        lng: this.agency.lng || 0
      }];
    }

  },
  async created() {
    await this.loadAgence();
  },
  methods: {
    async loadAgence() {
      const vue = this;
      await agencyService
        .getAgence()
        .then((res) => {
          if (res.success) {
            vue.agency = res.data.agency;
            vue.center = {
              lat: res.data.agency.lat || 0,
              lng: res.data.agency.lng || 0
            };
          }
        })
        .catch((err) => {
          vue.callToaster(vue.$t('problem-arise'));
        });
    },
  },
};
